class Table {
    generateVisibleFields = (data ,key, customFields = {}) => {
        const model = localStorage.getItem(key);
        let fields = {}
        data?.forEach(item => {
            fields[item.field] = true
        })
        fields = {
            ...fields,
            ...customFields
        }
        return model ? {
            ...customFields,
            ...JSON.parse(model),
        } : fields
    }
}

export default new Table()